import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { QrCode } from "lucide-react";

const COLS = [["qr_scans", "QR scans"], ["link_taps", "Link taps"], ["watch_views", "Watched"], ["sound_on", "Sound on"], ["completed", "Finished"], ["pro_clicks", "Go Pro clicks"], ["signups", "Signups"], ["sellers", "Sellers"], ["paid", "Paid"]];

export default function CampaignPerformance() {
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => { api.get(`/events/campaigns?days=${days}`).then(({ data }) => setData(data)).catch(() => setData({ totals: {}, rows: [] })); }, [days]);
  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="campaign-performance-panel">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2"><QrCode className="h-4 w-4 text-[#FF3B30]" /><h2 className="font-black text-xl tracking-tight">Advert &amp; group tracking</h2></div>
        <div className="flex gap-1">
          {[7, 30, 90].map((d) => <button key={d} onClick={() => setDays(d)} data-testid={`campaign-days-${d}`} className={`px-3 py-1 rounded-full text-xs border ${days === d ? "bg-white text-black border-white" : "text-neutral-400 border-white/15 hover:bg-white/5"}`}>{d}d</button>)}
        </div>
      </div>
      <p className="mt-1 text-xs text-neutral-500">Every share link and QR code carries a group tag (<code>cmp=</code>). Scans and taps are counted on the server the moment the link opens; signups and paid sellers come from the accounts created through that tag.</p>
      {data && (
        <>
          <div className="mt-4 grid grid-cols-3 md:grid-cols-9 gap-2">
            {COLS.map(([k, label]) => (
              <div key={k} className="rounded-lg bg-black/40 border border-white/10 p-2 text-center" data-testid={`campaign-total-${k}`}>
                <div className={`font-black text-lg ${k === "paid" ? "text-[#FF3B30]" : ""}`}>{data.totals?.[k] ?? 0}</div>
                <div className="text-[10px] uppercase tracking-widest text-neutral-500">{label}</div>
              </div>
            ))}
          </div>
          {data.rows.length === 0 ? (
            <p className="mt-4 text-sm text-neutral-500" data-testid="campaign-empty">No tagged activity yet — send the share link from the Marketing kit to a group and this fills in live.</p>
          ) : (
            <div className="mt-4 overflow-x-auto">
              <table className="w-full text-xs" data-testid="campaign-table">
                <thead><tr className="text-left text-neutral-500 uppercase tracking-widest text-[10px]"><th className="py-2 pr-3">Group tag</th>{COLS.map(([k, l]) => <th key={k} className="py-2 pr-3 text-right">{l}</th>)}</tr></thead>
                <tbody>
                  {data.rows.map((r) => (
                    <tr key={r.cmp} className="border-t border-white/5" data-testid={`campaign-row-${r.cmp}`}>
                      <td className="py-2 pr-3 font-mono text-white">{r.cmp}</td>
                      {COLS.map(([k]) => <td key={k} className={`py-2 pr-3 text-right ${k === "paid" && r[k] > 0 ? "text-[#FF3B30] font-bold" : "text-neutral-300"}`}>{r[k] ?? 0}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
